module.exports = __webpack_public_path__ + "static/normal.f445f8df.png";